import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";
import Skeleton from "@material-ui/lab/Skeleton";
import useStyles from "../styles";

/**
 * CourseDetailsSkeleton — full-page placeholder shown while a course loads.
 * Mirrors the CourseDetails layout (header, map, scorecard, tee boxes)
 * so the page never renders as an empty shell.
 */
const CourseDetailsSkeleton = () => {
  const classes = useStyles();

  return (
    <Paper
      className={classes.detailsPaper}
      style={{ padding: "20px", borderRadius: "5px" }}
      elevation={6}
    >
      <div className={classes.courseDetailsNav}>
        <Skeleton variant="text" width={110} />
        <Skeleton variant="text" width={110} />
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={6} lg={6}>
          {/* Course name */}
          <Skeleton variant="text" width="75%" height={48} />
          {/* Star rating */}
          <Skeleton variant="text" width={160} height={32} />
          {/* Address lines */}
          <Skeleton variant="text" width="55%" />
          <Skeleton variant="text" width="45%" />
          <Skeleton variant="text" width="30%" />
          <Skeleton variant="text" width="40%" />
          {/* Chips */}
          <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "16px" }}>
            <Skeleton variant="rect" width={80} height={24} style={{ borderRadius: 12 }} />
            <Skeleton variant="rect" width={100} height={24} style={{ borderRadius: 12 }} />
            <Skeleton variant="rect" width={90} height={24} style={{ borderRadius: 12 }} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={8} md={6} lg={6} className={classes.courseMapContainer}>
          {/* Map */}
          <Skeleton variant="rect" width="100%" height={300} style={{ borderRadius: 8 }} />
        </Grid>
      </Grid>

      <Divider style={{ margin: "20px 0 50px" }} />

      {/* Scorecard */}
      <Skeleton variant="text" width={140} height={36} style={{ marginBottom: 20 }} />
      <Skeleton variant="rect" width="100%" height={220} style={{ borderRadius: 4, marginBottom: 20 }} />
      <Skeleton variant="rect" width="100%" height={220} style={{ borderRadius: 4 }} />

      <Divider style={{ margin: "50px 0" }} />

      {/* Tee boxes */}
      <Skeleton variant="text" width={120} height={36} style={{ marginBottom: 20 }} />
      <Skeleton variant="rect" width="60%" height={160} style={{ borderRadius: 4 }} />
    </Paper>
  );
};

export default CourseDetailsSkeleton;
